import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { blogArticles } from "@/data/blog";
import { ArrowUpRight } from "lucide-react";

const Blog = () => {
  const { t } = useLang();
  const featured = blogArticles[0];
  const rest = blogArticles.slice(1);

  return (
    <main data-testid="blog-page" className="bg-cream text-ink">
      {/* HERO */}
      <section className="pt-40 pb-12 md:pt-48 md:pb-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="overline">{t.blog_page.eyebrow}</p>
          <h1 className="mt-6 font-serif text-6xl md:text-8xl font-light tracking-tight leading-[0.95]">
            {t.blog_page.title}
          </h1>
          <p className="mt-8 max-w-2xl text-ink/75 font-light text-lg leading-relaxed">{t.blog_page.lede}</p>
        </div>
      </section>

      {/* FEATURED */}
      <section className="pb-16 border-t border-ink/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16">
          <Link to={`/blog/${featured.slug}`} data-testid={`blog-featured-${featured.slug}`} className="grid md:grid-cols-12 gap-8 md:gap-16 items-center group">
            <div className="md:col-span-7">
              <div className="aspect-[16/10] bg-ink overflow-hidden">
                <img src={featured.img} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
            </div>
            <div className="md:col-span-5">
              <p className="overline">{featured.category} · {featured.date}</p>
              <h2 className="mt-5 font-serif text-4xl md:text-5xl font-light leading-tight tracking-tight">{featured.title}</h2>
              <p className="mt-6 text-ink/75 font-light leading-relaxed">{featured.excerpt}</p>
              <div className="mt-6 flex items-center justify-between max-w-sm">
                <span className="overline text-ink/55">{featured.read}</span>
                <span className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase link-underline">
                  {t.blog_page.read_more} <ArrowUpRight size={14} />
                </span>
              </div>
            </div>
          </Link>
        </div>
      </section>

      {/* GRID */}
      <section className="pb-28 border-t border-ink/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 grid md:grid-cols-3 gap-10 md:gap-12">
          {rest.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
              <div className="aspect-[4/5] bg-ink overflow-hidden mb-6">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <p className="overline text-ink/60">{p.category} · {p.date}</p>
              <h3 className="mt-3 font-serif text-2xl font-light leading-snug group-hover:underline underline-offset-4 decoration-1">{p.title}</h3>
              <p className="mt-3 text-sm text-ink/70 font-light leading-relaxed">{p.excerpt}</p>
              <p className="mt-4 overline text-ink/55">{p.read}</p>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Blog;
